import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormatService } from 'src/app/_service/format.service';
import { KPIService } from 'src/app/_service/kpi.service';

@Component({
  selector: 'partnership-center',
  templateUrl: './partnership-center.component.html',
  styleUrls: ['./partnership-center.component.scss']
})

export class PartnershipCenterComponent {
  @Input() disabled: boolean = false;
  @Input() field: any;
  @Input() prefillAnswer: any;

  answers: Answers = {
    num_used: 0,
    total_stays: 0,
    facilities: [],
  }

  @Output() answerEmitter = new EventEmitter<Answers>();


  constructor(
    public kpi: KPIService,
    public format: FormatService
  ) {  

  }

  ngOnInit() {
    if(this.field.answer) this.answers = this.field.answer;
    if(this.prefillAnswer != "" && this.prefillAnswer != undefined) this.answers = this.prefillAnswer;
  }


  range(n: number) {
    n = Number(n) || 0;
    return Array.from({ length: n }, (_, i) => i);
  }

  formatNumber(event: any) {
    this.format.number(event);
    this.answerEmitter.emit(this.answers)
  }


  fillFacilities(event: any) {
    this.format.number(event)
    let count = event.target.value;

    //if we are adding more facilities, keep the existing ones and add more to reach the new count
    if(count > this.answers.facilities.length) {
      count = count - this.answers.facilities.length;

      for(let i = 0; i < count; i++) {
        this.answers.facilities.push({
          name: '',
          type: undefined,
          num_stays: undefined,
          men: undefined,
          women: undefined,
          children: undefined,
          disabled: undefined
        })
      }
    }
    else {
      this.answers.facilities = this.answers.facilities.slice(0, count);
    }

    this.answerEmitter.emit(this.answers)
  }


  updateCount(event: any) {
    this.format.number(event);
    this.answers.total_stays = 0;

    for(let f of this.answers.facilities) {
      if(f.men) this.answers.total_stays += parseInt(f.men.toString())
      if(f.women) this.answers.total_stays += parseInt(f.women.toString())
      if(f.children) this.answers.total_stays += parseInt(f.children.toString())
    }
    this.answerEmitter.emit(this.answers)
  }

}


interface Answers {
  num_used: number | undefined;
  total_stays: number;
  facilities: Facility[]
}

interface Facility {
  name: string;
  type: 'Warming'|'Cooling'|undefined;
  num_stays: number | undefined;
  men: number | undefined;
  women: number | undefined;
  children: number | undefined;
  disabled: number | undefined;
}